import {
  WIRCreateJourneyStepsKeys,
  WIRStageGate4SectionKey,
  WIRStageGate4Sections,
} from 'pages/WellGuardian/WIR/wir.constants';
import { WIR, WIRActionStatus } from 'types/wellGuardian';

export const getWirStageGate4Sections = (wir: WIR | null) =>
  (wir &&
    Object.keys(WIRStageGate4Sections)
      .map(item => ({
        label: WIRStageGate4Sections[item as WIRStageGate4SectionKey],
        value: item,
        phase: WIRCreateJourneyStepsKeys.STAGE_GATE_4,
      }))
      .filter(stepItem => {
        // Check for matching action with any phase label
        const matchingAction = wir?.actions?.find(item =>
          item.actionName?.includes(stepItem.label),
        );
        // If no matching action found, include the section
        // If matching action found, include only if it's NOT deleted
        return !matchingAction || matchingAction?.state !== WIRActionStatus.DELETED;
      })) ??
  [];
